var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cs-button',{attrs:{"width":"100%","loading":_vm.exportLoading,"label":"Export DOCX"},on:{"click":_vm.onExportDocx}})}
var staticRenderFns = []

export { render, staticRenderFns }